export default "__VITE_ASSET__ECyzqoyo__"